<div class="download-dialog dark-theme">
  <h2 class="dialog-title">{{ 'DOWNLOAD_DIALOG.TITLE' | translate }}</h2>

  <div class="file-info">
    <span class="file-name">{{ data.uploadedFileName }}</span>
  </div>

  <div class="format-selection">
    <h3>{{ 'DOWNLOAD_DIALOG.CHOOSE_FORMAT' | translate }}</h3>

    <div class="format-options-container">
      @for (format of formats; track format; let i = $index) {
      <button
        type="button"
        class="format-option"
        [class.selected]="_selectedFormat.Name === format"
        [style.background-color]="formatColor(i)"
        [disabled]="editorProcess()"
        (click)="selectFormat(format)"
        [attr.aria-pressed]="_selectedFormat.Name === format"
        [attr.aria-label]="'Format ' + format"
        [attr.title]="format">
        {{ getFormatAbbreviation(format) }}
      </button>
      }
    </div>
  </div>

  <div class="action-buttons">
    @if (editorProcess()) {
    <div class="action-buttons__spinner">
      <lib-spinner size="xl" variant="primary" />
    </div>
    } @else {
    @if (downloadLink()) {
    <a
      libButton
      variant="primary"
      class="w-full"
      target="_blank"
      [href]="downloadLink()"
      [attr.download]="downloadFileName() || null"
      (click)="onDownload()">
      <mat-icon class="size-4!" svgIcon="download"></mat-icon>
      {{ 'DOWNLOAD_DIALOG.DOWNLOAD' | translate }}
    </a>
    } @else {
    <button
      libButton
      variant="primary"
      class="w-full"
      type="button"
      (click)="onGetResult()"
      [disabled]="!_selectedFormat.Name">
      <mat-icon class="size-4!" svgIcon="download"></mat-icon>
      {{ 'DOWNLOAD_DIALOG.DOWNLOAD' | translate }}
    </button>
    }

    <button libButton variant="muted" type="button" (click)="dialogRef.close()">
      {{ 'DOWNLOAD_DIALOG.CANCEL' | translate }}
    </button>
    }
  </div>

  @if (errorMessage()) {
  <div class="dialog-error">
    {{ errorMessage() }}
  </div>
  }
</div>
